import gql from 'graphql-tag';

export const COMPANY_QUERY = gql`
  query getCompany($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      name

      hasPOS
      hasTables
      hasAppOrders
      hasKDS
      hasExpress
      hasInventory
      manualEndOfDay

      categories(filter: { deleted: false, company: { id: $companyId } }) {
        parentId
        id
        name
        vatRate
        courseType {
          id
        }
        nameLang {
          id
          se
          en
          es
        }
        order
      }

      courseTypes {
        id
        label
        name
        order
      }
    }
  }
`;
